export const tableHeaders = [
    {
        title: '품목',
        value: '',
        sortable: false,
        width: 149,
    },
    {
        title: '공급가액',
        value: '',
        sortable: false,
        width: 148,
        align: 'end',
    },
    {
        title: '세액',
        value: '',
        sortable: false,
        width: 148,
        align: 'end',
    },
    {
        title: '합계액',
        value: '',
        sortable: false,
        width: 188,
        align: 'end',
    },
    {
        title: '비고',
        value: '',
        sortable: false,
    },
];
export const itemType = {
    DELIVERY_CHARGE: 'deliveryFee',
    DELIVERY_CHARGE_REFUND: 'deliveryFee',
    MGMT_FEE_MONTHLY: 'monthlyExpense',
    MGMT_FEE_MONTHLY_REFUND: 'monthlyExpense',
    MGMT_FEE_PER_ORDER: 'perExpense',
    MGMT_FEE_PER_ORDER_REFUND: 'perExpense',
    STORE_FEE: 'commission',
    STORE_FEE_REFUND: 'commission',
    TOTAL: 'total',
};
export const itemText = {
    deliveryFee: '배달대행료',
    monthlyExpense: '월 관리비',
    perExpense: '건당 관리비',
    commission: '수수료',
    total: '총',
};
